export type Navigation = {
  name: string
  href: string
}

export type NavigationData = Navigation[]

export const navigationData: NavigationData = [
  // { name: 'Dashboard', href: '/' },
  { name: 'Earn', href: '/earn' },
  {
    name: 'Buy',
    href: 'https://xodex.app/#/swap?outputCurrency=0xBD40E2C830E1066D20E72a0cF2E55a19398752f6',
  },
  { name: 'Bridge', href: 'https://bridge.xodex.app' },
]
